exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header[data-v-4ea66ecb]{margin-bottom:1rem;padding-bottom:1rem;border-bottom:1px solid #eee}.staticBlockRow.blockRow[data-v-4ea66ecb]{max-width:calc(100% - 200px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4ea66ecb&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/MonthView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-4ea66ecb&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/MonthView.vue
// module chunks = 0